import React from "react";
import {Link, NavLink} from "react-router-dom";
import {useHasPermission} from "../../hooks/permission";

const CreateButton = ({ to, label = "Create New", permission }) => {
    const hasAccess = useHasPermission(permission);

    if(permission && !hasAccess){
        return '';
    }

    return (
        <Link to={to} className="btn btn-primary btn-set-task w-sm-100"><i className="icofont-plus-circle me-2 fs-6"></i>{label}</Link>

    );
};

export default CreateButton;